import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, WifiOff } from "lucide-react";

// Pagina di accesso: ingresso ben visibile alla consultazione senza server (Ispezione ASL/NAS di emergenza).
export default function OfflineAccessButton() {
  return (
    <Link to="/ispezione-offline" data-testid="link-offline-inspection"
      className="group mt-6 flex items-center gap-3 rounded-xl bg-gradient-to-r from-red-600 to-red-700 px-4 py-3.5 text-left text-white shadow-lg shadow-red-900/20 ring-1 ring-red-400/40 transition-[transform,background-color,box-shadow] hover:-translate-y-0.5 hover:from-red-500 hover:to-red-600 hover:shadow-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-600 focus-visible:ring-offset-2">
      <span className="grid h-11 w-11 shrink-0 place-items-center rounded-lg bg-white/15 ring-1 ring-white/25">
        <WifiOff className="h-5 w-5" strokeWidth={1.75} />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block font-heading text-base font-semibold leading-tight sm:text-lg">Server non raggiungibile?</span>
        <span className="mt-0.5 block text-xs text-red-50/90 sm:text-sm">Apri senza Internet i report e la procedura di emergenza salvati su questo dispositivo</span>
      </span>
      <ChevronRight className="h-5 w-5 shrink-0 opacity-80 transition-transform group-hover:translate-x-0.5" />
    </Link>
  );
}
